module.exports = __webpack_public_path__ + "img/maryorisaladana.05e5b57d.jpeg";